import { render, staticRenderFns } from "./DynamicAttributeOptionForm.vue?vue&type=template&id=791ec676&"
import script from "./DynamicAttributeOptionForm.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeOptionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports